import { singleArrayData } from '@/shared/utils';
import type { CareerOption, StudentResponseEntity } from './student.entity';

/**
 * Servicio de dominio para extracción y manipulación de datos de carreras
 * Encapsula la lógica de negocio relacionada con carreras
 */
export class CareerExtractionService {
  /**
   * Extrae las opciones únicas de carreras desde una lista de estudiantes
   */
  static extractCareerOptions(
    students: StudentResponseEntity[],
  ): CareerOption[] {
    if (!students || students.length === 0) {
      return [];
    }

    const uniqueCareers = singleArrayData<StudentResponseEntity>({
      data: students,
      key: 'career_short_name',
    });

    return uniqueCareers.map((career) => ({
      key: career.toLowerCase(),
      label: career,
    }));
  }

  /**
   * Valida si una carrera existe en la lista de estudiantes
   */
  static isValidCareer(
    careerName: string,
    students: StudentResponseEntity[],
  ): boolean {
    return students.some(
      (student) =>
        student.career_short_name.toLowerCase() === careerName.toLowerCase(),
    );
  }

  /**
   * Obtiene el conteo de estudiantes por carrera
   */
  static getCareerCount(
    students: StudentResponseEntity[],
  ): Record<string, number> {
    return students.reduce(
      (acc, student) => {
        const career = student.career_short_name;
        acc[career] = (acc[career] || 0) + 1;
        return acc;
      },
      {} as Record<string, number>,
    );
  }
}
